export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },

  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',

    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_title_techGoodsCutting_No') || '裁片编号',
    field: 'techGoodsCuttingNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_title_seq_No') || '面料序号',
    field: 'seqno',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_title_fabricPosition') || '面料位置',
    field: 'v_fabricPosition',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_title_cuttingQty') || '裁剪片数',
    field: 'cuttingQty',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_cutting_size_Desc') || '裁剪尺寸',
    field: 'cuttingSizeDesc',
    minWidth: 130,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

]
